// extracted by mini-css-extract-plugin
export var explainable = "_br-a";
export var printerCard = "_br-1";
export var printerCardConfigured = "_br-2";
export var printerCardError = "_br-3";
export var printerCardsContainer = "_br-0";
export var printerIcon = "_br-8";
export var printerIconConfigured = "_br-5";
export var printerIconContainer = "_br-4";
export var printerIconError = "_br-6";
export var printerIconUnconfigured = "_br-7";
export var workstationsTableCard = "_br-9";